import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {
  @Input() paginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  @Input() isShowChangeRecordOfPage = true;
  // cho phep man host an dong "khong tim thay ban ghi nao" khi dang tai (skeleton)
  @Input() isShowNoRecord = true;

  @Output() changeTotalRecord = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<any>();

  constructor(
    public commonService: CommonService
    ) { }

  checkFocus = true;
  ngOnInit() {
    // this.paginate.pageSize = 10;
  }

  /**
   * On change pagination
   * @param event: Event
   * @param pageNo: number
   */
  onPageChange(event: Event, pageNo: number) {
    event.preventDefault();
    if (pageNo < 1 || pageNo > this.paginate.totalPage) {
      return;
    }
    this.pageChange.next({ page: pageNo - 1, pageSize: this.paginate.pageSize });
  }

  /**
   * On change total record per page
   */
  onChangeTotalRecord() {
    this.pageChange.next({ page: 0, pageSize: this.paginate.pageSize });
  }

}
